import { render } from "./step-number.vue?vue&type=template&id=28836651"
import script from "./step-number.vue?vue&type=script&lang=js"
export * from "./step-number.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__